module.exports = __webpack_public_path__ + "static/media/shape3_6.9401806e.obj";